import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Button, ButtonGroup, Modal } from 'react-bootstrap';
import ReactTable from 'react-table';

import modal from '../../typings/Modal';
import Model from '../../model/ShopKeeper.model';
import LoadingPage from '../../../LoadingPage';
import AuthService from '../../../../services/AuthService';

interface IProps {
  container: Object;
  hide: () => void;
  model: Model;
  show: boolean;
}

// We want case insensitive and searching within strings
const filterOverride = ({ id, value }: { id: string; value: string }, row: string[]) => {
  return row[id] ? row[id].toLowerCase().includes(value.toLowerCase()) : false;
};

@observer
class CustomerVehiclesModal extends Component<IProps, {}> {
  render() {
    const { container, hide, model, show } = this.props;

    return (
      <Modal backdrop="static" size="xl" container={container as any} onHide={hide as any} show={show}>
        <Modal.Header>
          <Modal.Title>Vehicles - Customer: {model.activeCustomerID}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {model.customerVehiclesLazyLoaded ? (
            model.customerVehicles.length > 0 ? (
              <div style={{ height: '405px' }}>
                <ReactTable
                  className="-striped"
                  data={model.customerVehicles}
                  defaultFilterMethod={filterOverride}
                  defaultPageSize={model.customerVehicles.length}
                  showPagination={false}
                  style={{
                    maxHeight: '400px',
                  }}
                  columns={[
                    {
                      Cell: props => (
                        <ButtonGroup>
                          <button
                            className="btn btn-secondary btn-xs"
                            title="History"
                            onClick={() =>
                              modal.open('vehicleHistory', {
                                lookupKey: props.original.vin,
                              })
                            }
                          >
                            <i className="fad fa-history fa-fw" />
                          </button>
                          <button
                            className="btn btn-secondary btn-xs"
                            title="Part History"
                            onClick={() =>
                              modal.open('vehiclePartHistory', {
                                lookupKey: props.original.vin,
                              })
                            }
                          >
                            <i className="fad fa-toolbox fa-fw" />
                          </button>
                          <button
                            className="btn btn-secondary btn-xs"
                            title="Details"
                            onClick={() =>
                              modal.open('vehicleInformation', {
                                lookupKey: props.original.vin,
                              })
                            }
                          >
                            <i className="fad fa-truck-container fa-fw" />
                          </button>
                          <button
                            className="btn btn-secondary btn-xs"
                            title="Attachments"
                            onClick={() =>
                              modal.open('attachments', {
                                itemId: props.original.vin,
                                itemName: 'SUF2',
                                readOnly: true,
                              })
                            }
                          >
                            <i className="fad fa-paperclip fa-fw" />
                          </button>
                        </ButtonGroup>
                      ),
                      style: {
                        textAlign: 'center',
                      },
                      width: 115,
                    },
                    {
                      Header: 'Vin',
                      accessor: 'vin',
                      filterable: true,
                      style: {
                        textAlign: 'center',
                      },
                    },
                    {
                      Header: 'Stock #',
                      accessor: 'stockNumber',
                      filterable: true,
                      style: {
                        textAlign: 'center',
                      },
                    },
                    {
                      Header: 'Year',
                      accessor: 'year',
                      filterable: true,
                      style: {
                        textAlign: 'center',
                      },
                      width: 75,
                    },
                    {
                      Header: 'Make',
                      accessor: 'make',
                      filterable: true,
                      style: {
                        textAlign: 'center',
                      },
                    },
                    {
                      Header: 'Model',
                      accessor: 'model',
                      filterable: true,
                      style: {
                        textAlign: 'center',
                      },
                    },
                  ]}
                />
              </div>
            ) : (
              <div style={{ marginTop: '15px' }}>No vehicles found for this customer.</div>
            )
          ) : (
            <LoadingPage />
          )}
        </Modal.Body>
        <Modal.Footer>
          <div style={{ display: 'flex', justifyContent: 'space-between', textAlign: 'left', width: '100%' }}>
            <div>
              {model.customerVehiclesLazyLoaded ? (
                <>
                  <Button
                    onClick={() => {
                      model.loadCustomerVehicles();
                    }}
                    variant="secondary"
                  >
                    <i className="zmdi zmdi-refresh" /> Refresh
                  </Button>
                  {AuthService.hasPermission('SUF2') && (
                    <Button
                      onClick={() => {
                        modal.open('listEditItem', {
                          action: 'new',
                          dialogClass: 'fitted',
                          headerClass: 'primary',
                          hideFooter: true,
                          hidePrint: true,
                          itemName: 'SUF2',
                          query: { SUF2A__17: model.activeCustomerID },
                          render: 'listEditItem',
                          title: `Add Vehicle - Customer ${model.activeCustomerID}`,
                        });
                      }}
                    >
                      Add Vehicle
                    </Button>
                  )}
                </>
              ) : null}
            </div>
            <div>
              <Button variant="secondary" onClick={hide}>
                Close
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default CustomerVehiclesModal;
